import { Button, Image, Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

const antIcon = <Loading3QuartersOutlined spin />;

export default (props: any) => {
  const { onClose, title, descriptorsData, activeNumber } = props;
  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={false}>
      <div className="eTableModal">
        <div className="modal_header">
          <div className="title"> {title} </div>
          <div className="close_icon">
            <Button
              size="large"
              type="link"
              className="p-0 m-20 close_popup"
              onClick={() => onCloseHandler()}
            >
              <Image src="/images/close-icon.svg" preview={false} width={10} />
            </Button>
          </div>
        </div>

        <div className="modal_content descriptor_modal">
          <label className="descriptor_role">
            <h6 className={`tagNumber_${activeNumber}`}>{activeNumber}</h6>{" "}
            <div className="desc_name">{descriptorsData?.name}</div>
          </label>
          <ul className="descriptor_list">
            {descriptorsData?.petal?.descriptors?.map(
              (descriptor: any, index: number) => (
                <li key={index}>
                  <div className="descriptor_title">
                    {descriptor?.descriptor}
                  </div>
                  <p>{descriptor?.category}</p>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </Spin>
  );
};
